/*********************
 * Mobillor Technologies Pvt. ltd. CONFIDENTIAL
 * __________________
 *
 *  Mobillor Technologies Pvt. Ltd.
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobillor Technologies Pvt. Ltd.
 * The intellectual and technical concepts contained
 * herein are proprietary to Mobillor Technologies Pvt. Ltd.
 * may be covered by Rebublic Of India and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobillor Technologies Pvt. Ltd.
 */

import { useNavigate } from "react-router-dom";

import { useCallback, useEffect, useState } from "react";
import { connect } from "react-redux";
import Select from "react-select";
// Formik and Yup

// Dashboard components
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";

// Dashboard example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import DataTable from "examples/Tables/DataTable";

// @mui material components
import Alert from "@mui/material/Alert";
import Card from "@mui/material/Card";
import Collapse from "@mui/material/Collapse";
import Grid from "@mui/material/Grid";
import Icon from "@mui/material/Icon";
import Tooltip from "@mui/material/Tooltip";
import DatePicker from "react-datepicker";

// Notification
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
// Functions from store
import {
  createDynamicColumn,
  downloadAgeingReport,
  getAgeingParameter,
  getAgeingReport,
  getAgeingReportDownload,
  getDynamicColumn,
  getItemTypesForStatus,
  getLevel1ByLevel,
  getLevel2ByLevel,
  getLevel3ByLevel,
  getLevel4ByLevel,
  getLocations,
  getLocationsByAgeing,
  getSubModulesByRoleId,
  getWarehouses,
} from "../../../store";

import { CSVLink } from "react-csv";

// config file
import Config from "../../../config/index";

// Cookies
import CloseIcon from "@mui/icons-material/Close";
import { Backdrop, CircularProgress, IconButton, Modal } from "@mui/material";
import MDCard from "components/MDCard";
import { addDays, addMinutes, format, subDays } from "date-fns";
import Cookies from "universal-cookie";
import TextError from "utils/TextError";
const cookies = new Cookies();

const desLength = Config.descriptionLength;

const AgeingReports = ({
  getSubModulesByRoleId,
  getSubModulesByRoleIdReducer,
  getItemTypeReducer,
  getAgeingParameterReducer,
  getItemTypesForStatus,
  getAgeingReportReducer,
  getAgeingParameter,
  getAgeingReportDownload,
  getAgeingReport,
  getLocationsByAgeingReducer,
  getAgeingReportDownloadReducer,
  getLocationsByAgeing,
  downloadAgeingReportReducer,
  downloadAgeingReport,
  getLocations,
  createDynamicColumn,
  getDynamicColumn,
  getLevel2ByLevel,
  getLevel3ByLevel,
  getLevel4ByLevel,
  warehouses,
  getWarehouses,
  getLevel1ByLevel,
  getLevel1ByLevelReducer,
  getLevel2ByLevelReducer,
  getLevel3ByLevelReducer,
  getWarehouseOccupancyReducer,
  getLevel4ByLevelReducer,
  downloadWarehouseOccupancyReducer,
  getWarehouseOccupancy,
  getWarehouseOccupancyDownload,
  getDynamicColumnReducer,
}) => {
  let loginDetails = cookies.get("loginDetailsForWMS");

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: { xs: 350, sm: 400, md: 520 },
    maxHeight: "90vh",
    // Remove or adjust overflowY
    // overflowY: "visible",
    boxShadow: 24,
    p: 2,
    bgcolor: "background.paper",
    borderRadius: 3,
    zIndex: 1400,
  };
  const styleForColumnReorder = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 380,
    color: "black",
    // border: "2px solid #000",
    boxShadow: 24,
    p: 2,
    pt: 3,
  };

  let jwtToken = loginDetails?.jwt;
  let roleId = loginDetails.data.roleId;

  useEffect(() => {
    getSubModulesByRoleId(roleId, jwtToken);
  }, [roleId]);

  useEffect(() => {
    getItemTypesForStatus(jwtToken);
  }, []);

  useEffect(() => {
    getWarehouses(jwtToken);
  }, []);

  useEffect(() => {
    getAgeingParameter(jwtToken);
  }, []);
  const [selectedAgeingType, setSelectedAgeingType] = useState("");
  const [selectedItemType, setSelectedItemType] = useState("");
  const [parameterSelected, setparameterSelected] = useState("");
  const [selectedLocation, setSelectedLocation] = useState("");

  const [pageNo, setPageNo] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [searchObject, setSearchObject] = useState(JSON.stringify({}));
  const [paginationObj, setPaginationObj] = useState({});
  const [errorMsgFromApi, setErrorMsgFromApi] = useState("");

  const importPageNo = (pageIndex) => {
    setPageNo(pageIndex === -1 ? pageNo : pageIndex);
  };

  const importRowsPerPage = (pageSize) => {
    setRowsPerPage(pageSize);
  };

  const importSearch = (globalFilter) => {
    setSearchObject(globalFilter ? JSON.stringify(globalFilter) : "");
  };
  const [refresh, setRefresh] = useState("");
  // setTimeout(() => {
  //   setRefresh(!refresh);
  // }, 60000);

  // useEffect(() => {
  //   getAgeingReportDownload(
  //     pageNo,
  //     rowsPerPage,
  //     searchObject,
  //     selectedItemType ? selectedItemType.value : "",
  //     selectedLocation ? selectedLocation.value : "",
  //     parameterSelected ? parameterSelected.value : "",
  //     selectedAgeingType ? selectedAgeingType.value : "",
  //     jwtToken
  //   );
  // }, [
  //   pageNo,
  //   rowsPerPage,
  //   searchObject,
  //   selectedItemType,
  //   selectedLocation,
  //   parameterSelected,
  //   selectedAgeingType,
  // ]);

  useEffect(() => {
    getLocationsByAgeing(
      selectedAgeingType ? selectedAgeingType.value : "",
      jwtToken,
    );
  }, [selectedAgeingType]);
  const [modulesData, setModulesData] = useState([]);

  useEffect(() => {
    setModulesData(
      getSubModulesByRoleIdReducer.subModulesByRoleData.data
        ? getSubModulesByRoleIdReducer.subModulesByRoleData.data
        : [],
    );
  }, [getSubModulesByRoleIdReducer]);

  let ageingReportModule = modulesData.find(
    (moduleId) => moduleId.moduleId == "80442bed-11bb-4717-a4d9-3b652c177a0e",
  );

  let viewAccess = ageingReportModule
    ? ageingReportModule.actionId.includes(
        "934f663b-39f3-4c9b-96ed-324ae1b4ae7d",
      )
    : null;

  const navigate = useNavigate();

  const [state, setState] = useState({
    columns: [
      { Header: "Item Code", accessor: "itemCode" },
      {
        Header: "Item Description",
        accessor: "itemDescription",
        align: "left",
        width: 320,
      },

      { Header: "Location", accessor: "locationCode" },
      { Header: "Document Number", accessor: "documentNumber" },
      { Header: "QTY", accessor: "qty" },
      { Header: "Uom", accessor: "uom" },
      { Header: "SKU", accessor: "sku" },
      { Header: "SUID", accessor: "suid" },
      { Header: "Ageing", accessor: "ageing" },
      // { Header: "createdDate", accessor: "createdDate" },
      {
        Header: "Created Date",

        accessor: "cd",
        align: "left",
        searchType: "date",
        Cell: ({ value }) => {
          return value
            ? format(
                addMinutes(
                  new Date(value),
                  new Date(value).getTimezoneOffset(),
                ),
                "dd/MM/yyyy hh:mm aaa",
              )
            : "";
        },
      },
    ],
    rows: [],
  });
  const { columns, rows } = state;

  const handleAgeingChange = (selectedOption) => {
    setSelectedAgeingType(selectedOption);
    setSelectedItemType("");
    setSelectedLocation("");
    // setparameterSelected("");
  };

  const ageingOptions = [
    { label: "Inventory Ageing", value: "RMW" },
    { label: "FG Ageing", value: "FG" },
    { label: "Rejection Ageing", value: "REJ" },
  ];

  const [itemTypeOptions, setItemTypeOptions] = useState([]);

  const handleItemTypeChange = (selectedItemCode) => {
    setSelectedItemType(selectedItemCode);
    setSelectedLocation("");
    // setparameterSelected("");
  };

  useEffect(() => {
    let tempItemCodeOptions = [];
    let data = getItemTypeReducer.itemTypes.data
      ? getItemTypeReducer.itemTypes.data
      : [];
    data.map((item) => {
      let des = item?.itemDescription;
      let len = desLength;
      tempItemCodeOptions.push({
        label: item.itemType,
        value: item.itemTypeId,
        // uom: item.uom,
      });
    });
    setItemTypeOptions(tempItemCodeOptions);
  }, [getItemTypeReducer]);

  const handleParameterChange = (selectedOption) => {
    setparameterSelected(selectedOption);
  };

  const [parameterOptions, setParameterOptions] = useState([]);

  useEffect(() => {
    let tempCreatedActivityOptions = [];
    let data = getAgeingParameterReducer.ageingParameter
      ? getAgeingParameterReducer.ageingParameter
      : [];
    data.map((activity) => {
      tempCreatedActivityOptions.push({
        label: activity.ageingValue,
        value: activity.ageingValue,
      });
    });

    setParameterOptions(tempCreatedActivityOptions);

    // Find and set default value "1 Week"
    const defaultOption = tempCreatedActivityOptions.find(
      (option) => option.value === "1 Week",
    );
    if (defaultOption) {
      setparameterSelected(defaultOption); // assuming you're using a state variable for selected value
    }
  }, [getAgeingParameterReducer]);

  const [loading, setLoading] = useState(true);
  let getAgeingReportReducerx = getAgeingReportReducer;
  useEffect(() => {
    let tempFinishedGoods = [];
    let data = getAgeingReportReducer.ageing.data
      ? getAgeingReportReducer.ageing.data
      : [];
    setLoading(getAgeingReportReducer.loading);

    setPaginationObj(getAgeingReportReducer.ageing?.pagination);
    data?.map((finishedGoods) => {
      const formatDate = new Date(finishedGoods.cd);

      let len = desLength;
      const finishedGoodsObject = {
        itemCode: finishedGoods.itemCode,
        itemDescription: (
          <span style={{ display: "flex", alignItems: "center" }}>
            {finishedGoods?.itemDescription?.length > 35 ? (
              <Tooltip
                title={finishedGoods.itemDescription}
                style={{ cursor: "pointer" }}
              >
                <MDTypography
                  variant="h6"
                  fontWeight="regular"
                  style={{ fontSize: "14px" }}
                >
                  {finishedGoods.itemDescription.substring(0, len)}
                </MDTypography>
              </Tooltip>
            ) : (
              <MDTypography
                variant="h6"
                fontWeight="regular"
                style={{ fontSize: "14px" }}
              >
                {finishedGoods.itemDescription}
              </MDTypography>
            )}
            {finishedGoods?.itemDescription?.length > 35 && (
              <span style={{ marginLeft: "0.1rem" }}>...</span>
            )}
          </span>
        ),
        locationCode: finishedGoods.locationCode,
        documentNumber: finishedGoods.documentNumber,
        qty: `${finishedGoods.qty} `,
        uom: `${finishedGoods.uom} `,
        sku: finishedGoods.sku,
        ageing: finishedGoods.ageing,
        suid: finishedGoods.suid,
        cd: format(
          addMinutes(formatDate, formatDate.getTimezoneOffset()),
          "dd/MM/yyyy hh:mm aaa",
        ),
        createdDate2: format(
          addMinutes(formatDate, formatDate.getTimezoneOffset()),
          "dd/MM/yyyy hh:mm aaa",
        ),
        cd: finishedGoods.cd,
        status: (
          <button
            className={
              (finishedGoods.documentStatus === 1 && `status-success`) ||
              (finishedGoods.documentStatus === 2 && `status-info`) ||
              (finishedGoods.documentStatus === 3 && `status-warning`)
            }
            style={{ width: "5.5rem" }}
          >
            {(finishedGoods.documentStatus === 1 && `Open`) ||
              (finishedGoods.documentStatus === 2 && `In-Progress`) ||
              (finishedGoods.documentStatus === 3 && `Closed`)}
          </button>
        ),
      };
      tempFinishedGoods.push(finishedGoodsObject);
    });
    setState({ ...state, rows: tempFinishedGoods });
  }, [getAgeingReportReducer]);

  const [createCircularModal, setCreateCircularModal] = useState(false);
  const handleCreateCircularModal = () => {
    setTimeout(() => {
      setCreateCircularModal(true);
    }, 500);
    setDownload("");
    setCustomDate("");
    setSelectedDateRange("");
    setDateRange([null, null]);
    // formik.setValues(initialValues);
    // formik.setTouched({});
    // formik.setErrors({});
  };
  const handleCreateCloseCircularModal = () => {
    setTimeout(() => {
      setCreateCircularModal(false);
    }, 500);
    setDownload("");
    setCustomDate("");
    setSelectedDateRange("");
    setDateRange([null, null]);
    // formik.setValues(initialValues);
    // formik.setTouched({});
    // formik.setErrors({});
  };
  const dateRangeOptions = [
    { label: "Last 7 Days", value: 7 },
    { label: "Last 30 Days", value: 30 },
    { label: "Last 3 Months", value: 90 },
    { label: "Custom date Range", value: "Custom date Range" },
  ];

  // useEffect(() => {
  //   getAgeingReport(
  //     pageNo,
  //     rowsPerPage,
  //     searchObject,
  //     selectedItemType ? selectedItemType.value : "",
  //     // selectedLocation ? selectedLocation.value : "",
  //     parameterSelected ? parameterSelected.value : "",
  //     selectedAgeingType ? selectedAgeingType.value : "",
  //     concatenatedLocation,
  //       warehousesCodesx,
  //     jwtToken
  //   );
  // }, [
  //   pageNo,
  //   rowsPerPage,
  //   searchObject,
  //   selectedItemType,
  //   // selectedLocation,
  //   parameterSelected,
  //   selectedAgeingType,
  //   concatenatedLocation,
  //   warehousesCodesx,
  // ]);

  const [Download, setDownload] = useState("");

  useEffect(() => {
    let tempFinishedGoods = [];
    let data = downloadAgeingReportReducer.ageing.data
      ? downloadAgeingReportReducer.ageing.data
      : [];
    // setLoading(downloadAgeingReportReducer.loading);

    // setPaginationObj(downloadAgeingReportReducer.ageing?.pagination);
    data?.map((finishedGoods) => {
      const formatDate = new Date(finishedGoods.cd);
      const finishedGoodsObject = {
        itemCode: finishedGoods.itemCode,
        itemDescription: finishedGoods.itemDescription,
        location: finishedGoods.locationCode,
        documentNumber: finishedGoods.documentNumber,
        qty: `${finishedGoods.qty} `,
        uom: `${finishedGoods.uom} `,
        sku: finishedGoods.sku,
        ageing: finishedGoods.ageing,
        suid: finishedGoods.suid,
        createdDate: format(
          addMinutes(formatDate, formatDate.getTimezoneOffset()),
          "dd/MM/yyyy hh:mm aaa",
        ),
        createdDate2: format(
          addMinutes(formatDate, formatDate.getTimezoneOffset()),
          "dd/MM/yyyy hh:mm aaa",
        ),
        cd: finishedGoods.cd,
        status: (
          <button
            className={
              (finishedGoods.documentStatus === 1 && `status-success`) ||
              (finishedGoods.documentStatus === 2 && `status-info`) ||
              (finishedGoods.documentStatus === 3 && `status-warning`)
            }
            style={{ width: "5.5rem" }}
          >
            {(finishedGoods.documentStatus === 1 && `Open`) ||
              (finishedGoods.documentStatus === 2 && `In-Progress`) ||
              (finishedGoods.documentStatus === 3 && `Closed`)}
          </button>
        ),
      };
      tempFinishedGoods.push(finishedGoodsObject);
    });
    setDownload(tempFinishedGoods);
  }, [downloadAgeingReportReducer]);

  const handleLocationChange = (selectedItemCode) => {
    setSelectedLocation(selectedItemCode);
    setparameterSelected("");
  };
  const [locationOptions, setLocationOptions] = useState([]);

  useEffect(() => {
    let tempItemCodeOptions = [];
    let data = getLocationsByAgeingReducer.locations
      ? getLocationsByAgeingReducer.locations
      : [];
    data.map((item) => {
      tempItemCodeOptions.push({
        label: item.locationCode,
        value: item.locationId,
      });
    });
    setLocationOptions(tempItemCodeOptions);
  }, [getLocationsByAgeingReducer]);

  const headers = [
    {
      label: "itemCode",
      key: "itemCode",
    },
    {
      label: "itemDescription",
      key: "itemDescription",
    },
    {
      label: "location",
      key: "location",
    },
    { label: "documentNumber", key: "documentNumber" },
    { label: "qty", key: "qty" },
    { label: "uom", key: "uom" },
    { label: "sku", key: "sku" },
    { label: "suid", key: "suid" },
    { label: "ageing", key: "ageing" },
    { label: "createdDate", key: "createdDate2" },
  ];

  const csvLink = {
    filename: "Age-ing Report.csv",
    headers: headers,
    data: Download,
  };

  const subModuleId = "80442bed-11bb-4717-a4d9-3b652c177a0e";
  let dynamicColumnDetails = cookies.get("dynamic-column-data");
  let userId = loginDetails.data.userId;
  let hiddenColumsDetails = cookies.get("hidden-column-data");

  useEffect(() => {
    getDynamicColumn(userId, subModuleId, jwtToken);
  }, [userId, subModuleId]);

  const [loadingForDynamicColumn, setLoadingForDynamicColumn] = useState(false);
  useEffect(() => {
    let data = getDynamicColumnReducer.dynamicColumn.data
      ? getDynamicColumnReducer.dynamicColumn.data
      : [];

    setDynamicColumnData(data);
    cookies.set("hidden-column-data", JSON.stringify(data?.notVisibleFields), {
      path: "/",
    });

    setTimeout(() => {
      setLoadingForDynamicColumn(true);
    }, 1000);
  }, [getDynamicColumnReducer, loading]);

  const [openCreateColumnReorderModal, setOpenCreateColumnReorderModal] =
    useState(false);

  const handleOpenCreateColumnReorderModal = () => {
    setOpenCreateColumnReorderModal(true);
  };

  const handleCloseCreateColumnReorderModal = () => {
    setOpenCreateColumnReorderModal(false);
  };

  const [dynamicColumnData, setDynamicColumnData] = useState("");
  const [isErrorColumnReorder, setIsErrorColumnReorder] = useState(false);
  const [isSuccessColumnReorder, setIsSuccessColumnReorder] = useState(false);

  useEffect(() => {
    if (isErrorColumnReorder) {
      setTimeout(() => {
        setIsErrorColumnReorder(false);
      }, 3000);
    }
  }, [isErrorColumnReorder]);

  useEffect(() => {
    if (isSuccessColumnReorder) {
      setTimeout(() => {
        setIsSuccessColumnReorder(false);
      }, 3000);
    }
  }, [isSuccessColumnReorder]);

  const [isErrorMsgForColumnReorder, setIsErrorMsgForColumnReorder] =
    useState(false);

  const handleDynamicColumn = async () => {
    let res = await createDynamicColumn(dynamicColumnDetails, jwtToken);
    if (res.status) {
      setIsSuccessColumnReorder(true);
      getDynamicColumn(userId, subModuleId, jwtToken);

      // getAgeingReport(
      //   pageNo,
      //   rowsPerPage,
      //   searchObject,
      //   selectedItemType ? selectedItemType.value : "",
      //   // selectedLocation ? selectedLocation.value : "",
      //   parameterSelected ? parameterSelected.value : "",
      //   selectedAgeingType ? selectedAgeingType.value : "",
      //   jwtToken
      // );
      setTimeout(() => {
        handleCloseCreateColumnReorderModal();
        // window.location.reload();
      }, 2250);
    }
    if (!res.status) {
      setIsErrorColumnReorder(true);
      setIsErrorMsgForColumnReorder(res?.data?.data?.msg);
    }
  };

  const [selectedOptions, setSelectedOptions] = useState({
    warehouse: [], // now an array
    zone: null,
    section: null,
    rack: null,
    location: null,
  });

  const isMultiWarehouse =
    Array.isArray(selectedOptions.warehouse) &&
    selectedOptions.warehouse.length > 1;

  const warehousesCodesx = Array.isArray(selectedOptions.warehouse)
    ? selectedOptions.warehouse.map((w) => w.label).join(",")
    : selectedOptions.warehouse?.label;

  const zones = Array.isArray(selectedOptions.zone)
    ? selectedOptions.zone.map((z) => z.label).join(",")
    : selectedOptions.zone?.label;

  const concatenatedLocation = isMultiWarehouse
    ? warehousesCodesx // Only show selected warehousesCodesx
    : [
        warehousesCodesx,
        zones,
        selectedOptions.section?.label,
        selectedOptions.rack?.label,
        selectedOptions.location?.label,
      ]
        .filter(Boolean)
        .join("-");

  const [warehouseOptions, setWarehouseOptions] = useState([]);
  useEffect(() => {
    let tempWarehouseOptions = [];
    let data = warehouses.warehouses ? warehouses.warehouses : [];
    data.map((warehouse) => {
      tempWarehouseOptions.push({
        label: warehouse.warehouseCode,
        value: warehouse.warehouseId,
        key: warehouse.warehouseCode,
      });
    });
    setWarehouseOptions(tempWarehouseOptions);
  }, [warehouses]);
  const [level1Options, setLevel1Options] = useState([]);

  useEffect(() => {
    let tempLevelOptions = [];
    let data = getLevel1ByLevelReducer.level1ByLevel.data
      ? getLevel1ByLevelReducer.level1ByLevel.data
      : [];
    data.map((level) => {
      tempLevelOptions.push({
        label: level.locationName,
        value: level.locationId,
        key: level.locationName,
      });
    });

    setLevel1Options(tempLevelOptions);
  }, [getLevel1ByLevelReducer]);

  const [level2Options, setLevel2Options] = useState([]);

  useEffect(() => {
    let tempLevelOptions = [];
    let data = getLevel2ByLevelReducer.level2ByLevel.data
      ? getLevel2ByLevelReducer.level2ByLevel.data
      : [];

    data.map((level) => {
      tempLevelOptions.push({
        label: level.locationName,
        value: level.locationId,
      });
    });

    setLevel2Options(tempLevelOptions);
  }, [getLevel2ByLevelReducer]);

  const [level3Options, setLevel3Options] = useState([]);

  useEffect(() => {
    let tempLevelOptions = [];
    let data = getLevel3ByLevelReducer.level3ByLevel.data
      ? getLevel3ByLevelReducer.level3ByLevel.data
      : [];

    data.map((level) => {
      tempLevelOptions.push({
        label: level.locationName,
        value: level.locationId,
      });
    });

    setLevel3Options(tempLevelOptions);
  }, [getLevel3ByLevelReducer]);

  // useEffect(() => {
  //   getWarehouseOccupancy(concatenatedLocation, jwtToken);
  // }, [concatenatedLocation, jwtToken]);

  // useEffect(() => {
  //   getWarehouseOccupancy(
  //     pageNo,
  //     rowsPerPage,
  //     searchObject,
  //     concatenatedLocation,
  //     warehousesCodesx,
  //     jwtToken
  //   );
  // }, [
  //   pageNo,
  //   rowsPerPage,
  //   searchObject,
  //   concatenatedLocation,
  //   warehousesCodesx,
  //   getWarehouseOccupancy,
  // ]);

  useEffect(() => {
    getAgeingReport(
      pageNo,
      rowsPerPage,
      searchObject,
      selectedItemType ? selectedItemType.value : "",
      // selectedLocation ? selectedLocation.value : "",
      parameterSelected ? parameterSelected.value : "",
      selectedAgeingType ? selectedAgeingType.value : "",
      concatenatedLocation,
      warehousesCodesx,
      jwtToken,
    );
  }, [
    pageNo,
    rowsPerPage,
    searchObject,
    selectedItemType,
    // selectedLocation,
    parameterSelected,
    selectedAgeingType,
    concatenatedLocation,
    warehousesCodesx,
  ]);

  const [selectedDateRange, setSelectedDateRange] = useState("");

  const handleDateRangeChange = (selected) => {
    setSelectedDateRange(selected);
  };

  const [customDate, setCustomDate] = useState("");
  const sevenDays = subDays(new Date(), 7).toISOString();
  const thityDays = subDays(new Date(), 30).toISOString();
  const nintyDays = subDays(new Date(), 90).toISOString();

  const [dateRange, setDateRange] = useState([null, null]);

  const [startDate, endDate] = dateRange;

  // useEffect(() => {
  //   getDateRange(jwtToken);
  // }, []);

  useEffect(() => {
    if (selectedDateRange?.value === 7) {
      setCustomDate(sevenDays);
    }
    if (selectedDateRange?.value === 30) {
      setCustomDate(thityDays);
    }
    if (selectedDateRange?.value === 90) {
      setCustomDate(nintyDays);
    }
  }, [selectedDateRange]);

  useEffect(() => {
    // Prevent double call: only trigger when customDate is set and either:
    // - dateRange has actual values (user-selected range)
    // - or dateRange is still default/null (not manually changed)
    if (!customDate) return;

    const finalStartDate =
      dateRange[0] !== null
        ? addDays(dateRange[0], 1)?.toISOString()
        : customDate;
    const finalEndDate =
      dateRange[1] !== null
        ? addDays(dateRange[1], 1)?.toISOString()
        : new Date().toISOString();

    downloadAgeingReport(
      finalEndDate,
      finalStartDate,
      pageNo,
      rowsPerPage,
      searchObject,
      selectedItemType?.value || "",
      parameterSelected?.value || "",
      selectedAgeingType?.value || "",
      concatenatedLocation,
      warehousesCodesx,
      jwtToken,
    );
  }, [
    customDate,
    dateRange[0],
    dateRange[1],
    selectedItemType,
    parameterSelected,
    selectedAgeingType,
    concatenatedLocation,
    warehousesCodesx,
  ]);

  // useEffect(() => {
  //   getWarehouseOccupancyDownload(
  //     pageNo,
  //     rowsPerPage,
  //     searchObject,
  //     concatenatedLocation,
  //     jwtToken
  //   );
  // }, [
  //   pageNo,
  //   rowsPerPage,
  //   searchObject,
  //   concatenatedLocation,
  //   getWarehouseOccupancy,
  // ]);

  // useEffect(() => {
  //   getWarehouseOccupancy(concatenatedLocation, jwtToken);
  // }, [concatenatedLocation, getWarehouseOccupancy, jwtToken]);

  const [level4Options, setLevel4Options] = useState([]);

  useEffect(() => {
    let tempLevelOptions = [];
    let data = getLevel4ByLevelReducer.level4ByLevel.data
      ? getLevel4ByLevelReducer.level4ByLevel.data
      : [];

    data.map((level) => {
      tempLevelOptions.push({
        label: level.locationName,
        value: level.locationId,
      });
    });

    setLevel4Options(tempLevelOptions);
  }, [getLevel4ByLevelReducer]);
  const handleChange = (level, newValue) => {
    setSelectedOptions((prevState) => {
      const newState = { ...prevState, [level]: newValue };

      const isMultiWarehouse =
        level === "warehouse" && Array.isArray(newValue) && newValue.length > 1;

      if (level === "warehouse") {
        // Always clear lower levels
        newState.zone = null;
        newState.section = null;
        newState.rack = null;
        newState.location = null;

        // Optional: prevent stale lower levels even if warehouse already has values
        if (Array.isArray(newValue) && newValue.length > 1) {
          newState.zone = null;
          newState.section = null;
          newState.rack = null;
          newState.location = null;
        }
      }

      if (isMultiWarehouse) {
        // If switching to multi warehouse, clear all lower levels
        newState.zone = null;
        newState.section = null;
        newState.rack = null;
        newState.location = null;
      }

      if (level === "zone" && !isMultiWarehouse) {
        newState.section = null;
        newState.rack = null;
        newState.location = null;
      }

      if (level === "section") {
        newState.rack = null;
        newState.location = null;
      }

      if (level === "rack") {
        newState.location = null;
      }

      return newState;
    });
  };

  const fetchLevelData = useCallback(() => {
    const { warehouse, zone, section, rack } = selectedOptions;

    const warehouseList = Array.isArray(warehouse) ? warehouse : [warehouse];

    if (warehouseList.length !== 1) return; // Abort if not exactly 1

    const selectedWarehouse = warehouseList[0];

    if (selectedWarehouse)
      getLevel1ByLevel(selectedWarehouse.value, 0, jwtToken);

    if (selectedWarehouse && zone) {
      const zoneList = Array.isArray(zone) ? zone : [zone];
      zoneList.forEach((z) => {
        getLevel2ByLevel(selectedWarehouse.value, z.value, jwtToken);
      });
    }

    if (selectedWarehouse && section)
      getLevel3ByLevel(selectedWarehouse.value, section.value, jwtToken);

    if (selectedWarehouse && rack)
      getLevel4ByLevel(selectedWarehouse.value, rack.value, jwtToken);
  }, [
    selectedOptions,
    getLevel1ByLevel,
    getLevel2ByLevel,
    getLevel3ByLevel,
    getLevel4ByLevel,
    jwtToken,
  ]);

  useEffect(() => {
    fetchLevelData();
  }, [fetchLevelData]);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={0} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                display="flex"
                flexDirection={{ xs: "column", lg: "row" }}
                justifyContent="space-between"
                alignItems="center"
                p={3}
                mb={-3}
                mt={-2}
              >
                <Grid container spacing={1}>
                  <Grid item xs={12} lg={12}>
                    <MDBox>
                      <MDBox
                        display="flex"
                        mt={2}
                        flexDirection={{ xs: "column", lg: "row" }}
                      >
                        {/* First: Ageing Type, Item Type, Ageing Parameter */}
                        <MDBox
                          width={{ xs: "120px", lg: "500px" }}
                          style={{ marginRight: "10px" }}
                        >
                          <MDTypography
                            variant="h6"
                            style={{ fontWeight: 500 }}
                          >
                            Ageing Type
                          </MDTypography>
                          <Select
                            isClearable
                            className="select-css-for-filter"
                            maxMenuHeight={380}
                            placeholder="Choose One..."
                            value={selectedAgeingType}
                            options={ageingOptions}
                            onChange={handleAgeingChange}
                          />
                        </MDBox>

                        <MDBox
                          width={{ xs: "120px", lg: "380px" }}
                          style={{ marginRight: "10px" }}
                        >
                          <MDTypography
                            variant="h6"
                            style={{ fontWeight: 500 }}
                          >
                            Item Type
                          </MDTypography>
                          <Select
                            isClearable
                            placeholder="Choose One..."
                            className="select-css-for-filter"
                            maxMenuHeight={380}
                            autoComplete="off"
                            options={itemTypeOptions}
                            value={selectedItemType}
                            onChange={handleItemTypeChange}
                          />
                        </MDBox>

                        <MDBox
                          width={{ xs: "120px", lg: "400px" }}
                          style={{ marginRight: "10px" }}
                        >
                          <MDTypography
                            variant="h6"
                            style={{ fontWeight: 500 }}
                          >
                            Ageing Parameter
                          </MDTypography>
                          <Select
                            isClearable
                            placeholder="Choose One..."
                            className="select-css-for-filter"
                            maxMenuHeight={380}
                            autoComplete="off"
                            value={parameterSelected}
                            options={parameterOptions}
                            onChange={handleParameterChange}
                          />
                        </MDBox>

                        {/* Then: Warehouse to Location Hierarchy */}
                        {[
                          {
                            label: "Warehouse",
                            value: "warehouse",
                            options: warehouseOptions,
                          },
                          {
                            label: "Zone",
                            value: "zone",
                            options: level1Options,
                            dependsOn: "warehouse",
                          },
                          {
                            label: "Section",
                            value: "section",
                            options: level2Options,
                            dependsOn: "zone",
                          },
                          {
                            label: "Partition",
                            value: "rack",
                            options: level3Options,
                            dependsOn: "section",
                          },
                          {
                            label: "Location",
                            value: "location",
                            options: level4Options,
                            dependsOn: "rack",
                          },
                        ].map(({ label, value, options, dependsOn }) => (
                          <MDBox
                            key={value}
                            width={{
                              xs: "100%",
                              lg: value === "warehouse" ? "420px" : "330px",
                            }}
                            style={{ marginRight: "10px" }}
                          >
                            <MDTypography
                              variant="h6"
                              style={{ fontWeight: 500 }}
                            >
                              {label}
                            </MDTypography>
                            <Select
                              isMulti={value === "warehouse"}
                              isClearable
                              isDisabled={
                                value !== "warehouse" &&
                                ((dependsOn && !selectedOptions[dependsOn]) ||
                                  (value === "zone" &&
                                    (!selectedOptions.warehouse ||
                                      (Array.isArray(
                                        selectedOptions.warehouse,
                                      ) &&
                                        selectedOptions.warehouse.length !==
                                          1))) ||
                                  (value !== "zone" &&
                                    Array.isArray(selectedOptions.warehouse) &&
                                    selectedOptions.warehouse.length > 1))
                              }
                              placeholder="Choose One ..."
                              className="select-css-for-filter"
                              maxMenuHeight={380}
                              autoComplete="off"
                              value={selectedOptions[value]}
                              options={options}
                              onChange={(newValue) =>
                                handleChange(value, newValue)
                              }
                            />
                          </MDBox>
                        ))}

                        <Grid>
                          <MDBox
                            color="text"
                            px={0}
                            display="flex"
                            flexDirection="column"
                          >
                            <MDBox
                              display="flex"
                              marginLeft={1}
                              marginTop="2rem"
                            >
                              {/* <CSVLink> */}
                              <Tooltip title="Download All Data">
                                <MDButton
                                  type="button"
                                  variant="outlined"
                                  color="success"
                                  iconOnly
                                  style={{ borderRadius: "5px" }}
                                  size="small"
                                  onClick={handleCreateCircularModal}
                                >
                                  <Icon>download</Icon>
                                </MDButton>
                              </Tooltip>
                              {/* </CSVLink> */}
                            </MDBox>
                          </MDBox>
                        </Grid>
                        <Modal
                          open={createCircularModal}
                          onClose={handleCreateCloseCircularModal}
                          aria-labelledby="modal-modal-title"
                          aria-describedby="modal-modal-description"
                        >
                          <MDCard sx={style} style={{ zIndex: 0 }}>
                            <MDBox
                              ml={3}
                              mt={-1}
                              display="flex"
                              alignItems="center"
                            >
                              <MDTypography
                                variant="h5"
                                fontWeight="medium"
                                flexGrow={1}
                              >
                                Download Report
                              </MDTypography>
                              <MDBox>
                                <Tooltip title="Close">
                                  <IconButton
                                    aria-label="close"
                                    color="inherit"
                                    onClick={handleCreateCloseCircularModal}
                                    style={{
                                      background: "whitesmoke",
                                      color: "black",
                                      borderRadius: 5,
                                      marginLeft: "-55px",
                                    }}
                                  >
                                    <CloseIcon />
                                  </IconButton>
                                </Tooltip>
                              </MDBox>
                            </MDBox>
                            <hr
                              style={{
                                marginTop: "0.5rem",
                                marginBottom: "1rem",
                              }}
                            />

                            <MDBox pt={1} pb={3} px={3}>
                              {/* <MDBox
                      component="form"
                      role="form"
                      onSubmit={formik.handleSubmit}
                    > */}
                              <MDBox
                                style={{
                                  marginRight: "5px",
                                  marginBottom: "10px",
                                }}
                              >
                                <MDTypography
                                  variant="h6"
                                  style={{ fontWeight: 500 }}
                                >
                                  Date Range
                                </MDTypography>
                                <Select
                                  // isClearable
                                  placeholder="Choose One..."
                                  className="select-css-for-filter"
                                  maxMenuHeight={130}
                                  options={dateRangeOptions}
                                  value={selectedDateRange}
                                  onChange={handleDateRangeChange}
                                />
                              </MDBox>
                              {selectedDateRange?.value ===
                                "Custom date Range" && (
                                <MDBox
                                  // width={{ xs: "125px", lg: "700px" }}
                                  style={{ marginRight: "5px" }}
                                >
                                  <MDTypography variant="h6">
                                    Custom Date Range
                                  </MDTypography>

                                  <DatePicker
                                    className="form-control"
                                    dateFormat="dd/MM/yyyy"
                                    placeholderText="Select date range"
                                    onChange={(date) => setDateRange(date)}
                                    isClearable={true}
                                    startDate={startDate}
                                    endDate={endDate}
                                    selectsRange={true}
                                    popperPlacement="right-end"

                                    // withPortal
                                  />

                                  {/* {formik.touched.startDate &&
                            formik.errors.startDate && (
                              <TextError msg={formik.errors.startDate} />
                            )} */}
                                </MDBox>
                              )}
                              {/* <MDBox>
                        <Collapse in={isError}>
                          <Alert
                            severity="error"
                            action={
                              <IconButton
                                aria-label="close"
                                color="inherit"
                                size="small"
                                onClick={() => {
                                  setIsError(false);
                                }}
                              >
                                <CloseIcon fontSize="inherit" />
                              </IconButton>
                            }
                          >
                            {errorMsg}
                          </Alert>
                        </Collapse>
                        <Collapse in={isSuccess}>
                          <Alert
                            severity="success"
                            action={
                              <IconButton
                                aria-label="close"
                                color="inherit"
                                size="small"
                                onClick={() => {
                                  setIsSuccess(false);
                                }}
                              >
                                <CloseIcon fontSize="inherit" />
                              </IconButton>
                            }
                          >
                            Circular Created successfully
                          </Alert>
                        </Collapse>
                      </MDBox> */}
                              <MDBox mt={3}>
                                {((selectedDateRange?.value ===
                                  "Custom date Range" &&
                                  dateRange[0] !== null) ||
                                  selectedDateRange) &&
                                  Download.length < 1 && (
                                    <TextError msg="No data found" />
                                  )}
                                {(selectedDateRange?.value ===
                                  "Custom date Range" &&
                                  dateRange[0] === null) ||
                                Download.length < 1 ||
                                !selectedDateRange ? (
                                  <MDButton
                                    color="success"
                                    fullWidth
                                    type="button"
                                    disabled
                                  >
                                    Submit
                                  </MDButton>
                                ) : (
                                  <CSVLink
                                    {...csvLink}
                                    onClick={() => {
                                      // Close modal after 2 seconds
                                      setTimeout(() => {
                                        handleCreateCloseCircularModal();
                                      }, 1000); // 2000ms = 2 seconds
                                    }}
                                  >
                                    <MDButton
                                      color="success"
                                      fullWidth
                                      type="button"
                                    >
                                      Submit
                                    </MDButton>
                                  </CSVLink>
                                )}
                              </MDBox>
                            </MDBox>
                            {/* </MDBox> */}
                          </MDCard>
                        </Modal>
                        <Modal
                          open={openCreateColumnReorderModal}
                          onClose={handleCloseCreateColumnReorderModal}
                          aria-labelledby="modal-modal-title"
                          aria-describedby="modal-modal-description"
                        >
                          <MDCard sx={styleForColumnReorder}>
                            <MDTypography>
                              Are you sure you want to submit?
                            </MDTypography>
                            <MDBox mt={2}>
                              <MDButton
                                style={{
                                  width: "10rem",
                                  marginRight: "0.5rem",
                                }}
                                color="info"
                                variant="outlined"
                                onClick={handleCloseCreateColumnReorderModal}
                              >
                                Cancel
                              </MDButton>
                              <MDButton
                                style={{ width: "10rem", marginLeft: "0.5rem" }}
                                color="success"
                                onClick={handleDynamicColumn}
                                // disabled={denyButtonName === "Please wait..."}
                              >
                                Submit
                              </MDButton>
                            </MDBox>
                            <MDBox mt={2}>
                              <Collapse in={isSuccessColumnReorder}>
                                <Alert
                                  severity="success"
                                  action={
                                    <IconButton
                                      aria-label="close"
                                      color="inherit"
                                      size="small"
                                      onClick={() => {
                                        setIsSuccessColumnReorder(false);
                                      }}
                                    >
                                      <CloseIcon fontSize="inherit" />
                                    </IconButton>
                                  }
                                >
                                  Data updated successfully!
                                </Alert>
                              </Collapse>
                              <Collapse in={isErrorColumnReorder}>
                                <Alert
                                  severity="error"
                                  action={
                                    <IconButton
                                      aria-label="close"
                                      color="inherit"
                                      size="small"
                                      onClick={() => {
                                        setIsErrorColumnReorder(false);
                                      }}
                                    >
                                      <CloseIcon fontSize="inherit" />
                                    </IconButton>
                                  }
                                >
                                  {isErrorMsgForColumnReorder}
                                </Alert>
                              </Collapse>
                            </MDBox>
                          </MDCard>
                        </Modal>
                      </MDBox>
                    </MDBox>
                  </Grid>
                </Grid>
                {/* <Grid item xs={12} lg={4}>
                  <MDBox style={{ marginTop: "25px", marginLeft: "8px" }}>
                          <MDBox>
                            <CSVLink {...csvLink}>
                              <DownloadDataButton
                                tooltip="Download All Data"
                                type="button"
                                variant="outlined"
                                color="success"
                                iconOnly
                              >
                                <Icon>download</Icon>
                              </DownloadDataButton>
                            </CSVLink>
                          </MDBox>
                        </MDBox>
                </Grid> */}
              </MDBox>

              <MDBox pt={3}>
                {loadingForDynamicColumn && (
                  <DataTable
                    table={{ columns, rows }}
                    isSorted={true}
                    tableSearch={true}
                    entriesPerPage={{
                      defaultValue: 5,
                      entries: [5, 10, 15, 20, 25, 30],
                    }}
                    showTotalEntries={true}
                    noEndBorder
                    serverSidePagination={true}
                    paginationObj={paginationObj}
                    pageNoValue={pageNo}
                    rowsPerPageValue={rowsPerPage}
                    pageNoProp={importPageNo}
                    rowsPerPageProp={importRowsPerPage}
                    searchProp={importSearch}
                    loading={loading}
                    hideColumns={hiddenColumsDetails}
                    visibleColumns2={dynamicColumnData?.visibleFields}
                    dynamicColumnData={dynamicColumnData}
                    handleOpenCreateColumnReorderModal={
                      handleOpenCreateColumnReorderModal
                    }
                    subModuleId={subModuleId}
                    userId={userId}
                  />
                )}
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      {loading && (
        <Backdrop
          sx={{ color: "blue", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      )}

      <ToastContainer />
    </DashboardLayout>
  );
};

const mapStateToProps = (state) => {
  return {
    getSubModulesByRoleIdReducer: state.getSubModulesByRoleIdReducer,
    getItemTypeReducer: state.getItemTypeReducer,
    getAgeingParameterReducer: state.getAgeingParameterReducer,
    getAgeingReportReducer: state.getAgeingReportReducer,
    getLocationsByAgeingReducer: state.getLocationsByAgeingReducer,
    getAgeingReportDownloadReducer: state.getAgeingReportDownloadReducer,
    downloadAgeingReportReducer: state.downloadAgeingReportReducer,
    getDynamicColumnReducer: state.getDynamicColumnReducer,
    warehouses: state.warehouses,
    getLevel1ByLevelReducer: state.getLevel1ByLevelReducer,
    getLevel2ByLevelReducer: state.getLevel2ByLevelReducer,
    getLevel3ByLevelReducer: state.getLevel3ByLevelReducer,
    getLevel4ByLevelReducer: state.getLevel4ByLevelReducer,
  };
};

const mapStateToDispatch = (dispatch) => {
  return {
    getSubModulesByRoleId: (roleId, jwtToken) =>
      dispatch(getSubModulesByRoleId(roleId, jwtToken)),
    getItemTypesForStatus: (jwtToken) =>
      dispatch(getItemTypesForStatus(jwtToken)),
    getAgeingParameter: (jwtToken) => dispatch(getAgeingParameter(jwtToken)),
    getAgeingReport: (
      pageNo,
      rowsPerPage,
      searchObject,
      selectedItemType,
      // selectedLocation,
      parameterSelected,
      selectedAgeingType,
      concatenatedLocation,
      warehouse,
      jwtToken,
    ) =>
      dispatch(
        getAgeingReport(
          pageNo,
          rowsPerPage,
          searchObject,
          selectedItemType,
          // selectedLocation,
          parameterSelected,
          selectedAgeingType,
          concatenatedLocation,
          warehouse,
          jwtToken,
        ),
      ),
    getAgeingReportDownload: (
      pageNo,
      rowsPerPage,
      searchObject,
      selectedItemType,
      selectedLocation,
      parameterSelected,
      selectedAgeingType,
      jwtToken,
    ) =>
      dispatch(
        getAgeingReportDownload(
          pageNo,
          rowsPerPage,
          searchObject,
          selectedItemType,
          selectedLocation,
          parameterSelected,
          selectedAgeingType,
          jwtToken,
        ),
      ),
    getLevel1ByLevel: (dWarehouseSelected, parentId, jwtToken) =>
      dispatch(getLevel1ByLevel(dWarehouseSelected, parentId, jwtToken)),
    getLevel2ByLevel: (warehouseId, parentId, jwtToken) =>
      dispatch(getLevel2ByLevel(warehouseId, parentId, jwtToken)),
    getLevel3ByLevel: (warehouseId, parentId, jwtToken) =>
      dispatch(getLevel3ByLevel(warehouseId, parentId, jwtToken)),
    getLevel4ByLevel: (warehouseId, parentId, jwtToken) =>
      dispatch(getLevel4ByLevel(warehouseId, parentId, jwtToken)),
    getLocations: (jwtToken) => dispatch(getLocations(jwtToken)),
    getLocationsByAgeing: (selectedAgeingType, jwtToken) =>
      dispatch(getLocationsByAgeing(selectedAgeingType, jwtToken)),

    getWarehouses: (jwtToken) => dispatch(getWarehouses(jwtToken)),
    downloadAgeingReport: (
      startDate,
      endDate,
      pageNo,
      rowsPerPage,
      searchObject,
      // selectedLocation,
      parameterSelected,
      selectedAgeingType,
      concatenatedLocation,
      warehouse,
      jwtToken,
    ) =>
      dispatch(
        downloadAgeingReport(
          startDate,
          endDate,
          pageNo,
          rowsPerPage,
          searchObject,
          // selectedLocation,
          parameterSelected,
          selectedAgeingType,
          concatenatedLocation,
          warehouse,
          jwtToken,
        ),
      ),
    getDynamicColumn: (userId, subModuleId, jwtToken) =>
      dispatch(getDynamicColumn(userId, subModuleId, jwtToken)),
    createDynamicColumn: (payload, jwtToken) =>
      dispatch(createDynamicColumn(payload, jwtToken)),
  };
};

export default connect(mapStateToProps, mapStateToDispatch)(AgeingReports);
